import { useObservabilityConfig, useProject } from "@sail/observability";
import { useMemo } from "react";
import mergeExpectedErrors from "./mergeExpectedErrors";
import useDataConfig from "../config/useDataConfig";
import useObservabilityFns from "../../shared/observability/useObservabilityFns";
export function useDataContext() {
    var _useObservabilityConfig;
    const observabilityFns = useObservabilityFns();
    const queryProject = useProject();
    const service = (_useObservabilityConfig = useObservabilityConfig()) === null || _useObservabilityConfig === void 0 ? void 0 : _useObservabilityConfig.service;
    const dataConfig = useDataConfig();
    const expectedErrorsFromDataConfig = dataConfig.observability.expectedErrors;
    return useMemo(()=>{
        return {
            expectedErrorsFromDataConfig,
            headers: {},
            observabilityFns,
            queryProject,
            service
        };
    }, [
        expectedErrorsFromDataConfig,
        observabilityFns,
        queryProject,
        service
    ]);
}
export function getApolloContext(dataContext, graphQlOperation, component) {
    const graphQlOperationWithAllExpectedErrors = mergeExpectedErrors(dataContext.expectedErrorsFromDataConfig, graphQlOperation);
    return {
        observabilityFns: dataContext.observabilityFns,
        queryProject: dataContext.queryProject,
        service: dataContext.service,
        headers: {},
        graphQlOperation: graphQlOperationWithAllExpectedErrors,
        component
    };
}

//# sourceMappingURL=operationContext.js.map